import { render, staticRenderFns } from "./Themas.vue?vue&type=template&id=8bf260bc&"
import script from "./Themas.vue?vue&type=script&lang=js&"
export * from "./Themas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports